module.exports = __webpack_public_path__ + "public/Icons/loginArrowDark.svg?b0ccab16";